'use client';

import { createContext, useContext } from 'react';
import type { RecentSearch } from './types';

interface SearchContextValue {
  /** What the field holds, as typed. */
  query: string;
  /** A result was opened: remember it and close the search. */
  select: (item: RecentSearch) => void;
  /** Put words into the field — a recent query chip. */
  setQuery: (query: string) => void;
  /** Close the search without remembering anything — a section's "See all". */
  close: () => void;
}

const SearchContext = createContext<SearchContextValue | null>(null);

export const SearchProvider = SearchContext.Provider;

export function useSearch(): SearchContextValue {
  const value = useContext(SearchContext);
  if (!value) throw new Error('useSearch must be used inside the search body');
  return value;
}
